import {isAgencyServerCMSArticle, isAgencyServerDevProjectArticle, isAgencyServerShopArticle} from "./ArticleNumbers";
import {APP_MODE_PRESET, ARTICLE_TYPE_CMS, ARTICLE_TYPE_DEV, ARTICLE_TYPE_SHOP, PROJECT_STATE_DEV, PROJECT_STATE_LIVE} from "../constants/General";
import {createSelector} from "reselect";
import {getProjectSelectionForm} from "./Forms";
import {getArticleOptionsData} from "./SimpleSelectors";
import {delve} from "../util/util";
import {getAppMode} from "./Mode";

export const getSelectedTypeByArticle = (articleNumber) => {
    if (isAgencyServerCMSArticle(articleNumber)) {
        return ARTICLE_TYPE_CMS;
    } else if (isAgencyServerShopArticle(articleNumber)) {
        return ARTICLE_TYPE_SHOP;
    } else if (isAgencyServerDevProjectArticle(articleNumber)) {
        return ARTICLE_TYPE_DEV;
    }
}

export const getSelectedStateByArticle = (articleNumber) => {
    // todo: use constants
    if (isAgencyServerDevProjectArticle(articleNumber)) {
        return PROJECT_STATE_DEV;
    } else {
        return PROJECT_STATE_LIVE;
    }
}

export const getSelectedArticleProjectSpace = createSelector(
    [getProjectSelectionForm, getArticleOptionsData, getAppMode],
    (projectSelectionForm, articleOptionsData, appMode) => {
        const currentValues = projectSelectionForm && projectSelectionForm.values;

        if (appMode === APP_MODE_PRESET) {
            return 0;
        } else {
            return currentValues && currentValues.article ? (Number(delve(articleOptionsData, currentValues.article+".projectSpace") || 0) / 1024 / 1024) : 0;
        }
    }
)

export const getSelectedStorageGB = createSelector(
    [getProjectSelectionForm, getArticleOptionsData],
    (projectSelectionForm, articleOptionsData) => {
        const currentValues = projectSelectionForm && projectSelectionForm.values;
        if (!currentValues || !currentValues.storage) {
            return 0;
        }
        const regex = /([\d.]{1,})/
        const storageGB = Number(regex.exec(articleOptionsData[currentValues.storage].title)[1]);
        return storageGB ? storageGB : 0;
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/ArticleConfigurator.js
 **/